exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-upload-img .el-form-item__content img {\n  width: 200px;\n  margin-right: 10px;\n  display: inline-block;\n}\n.demo-table-expand .el-form-item {\n  margin-right: 0;\n  margin-bottom: 0;\n  width: 100%;\n}\n", ""]);

// exports
